module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG0d9ad919e9d0142ef3225f57cb9238ca.0d9ad919.png";